// extracted by mini-css-extract-plugin
export default {"container":"SalonName_container__jQ72X","userName":"SalonName_userName__NS6qv","salonName":"SalonName_salonName__uWJ-u"};